import { FC } from "react";
import { SlArrowRight } from "react-icons/sl"
import { Link } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  url: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: FC<BreadcrumbProps> = ({ items }) => {
  return (
    <nav className="flex items-center text-sm">
      <ol className="flex items-center space-x-2">
        {items.map((item, index) => (
          <li key={item.url}>
            {index > 0 && <span className="m-1 float-left mr-2"><SlArrowRight /></span>}
            {index === items.length - 1 ? (
              <span className="text-slate-500">{item.label}</span>
            ) : (
              <Link to={item.url} className="text-blue-500 hover:underline">
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;